module.exports = __webpack_public_path__ + "img/lead-empty.3664d20a.png";